
import { SET_SELECTED_CUSTOMER_ORDER, SET_CUSTOMER_ORDER_SUMMARY_ITEMS, CLEAR_SELECTED_CUSTOMER_ORDER_DATA, SET_CUSTOMER_ORDERS, SET_CUSTOMER_ORDER_CONFLICT_RES } from './actionTypes'

export const saveCustomerOrderList = (data: any) => {
  return {
      type: SET_CUSTOMER_ORDERS,
      data
  };
};

export const saveSelectedCustomerOrder = (data: any) => {
  return {
      type: SET_SELECTED_CUSTOMER_ORDER,
      data
  };
};


export const saveCustomerOrderSummaryItems = (data: any) => {
  return {
      type: SET_CUSTOMER_ORDER_SUMMARY_ITEMS,
      data
  };
};

export const saveCustomerOrderConflictRes = (data: any) => {
  return {
      type: SET_CUSTOMER_ORDER_CONFLICT_RES,
      data
  };
};


export const clearSelectedCustomerOrderData = () => {
  return {
      type: CLEAR_SELECTED_CUSTOMER_ORDER_DATA
  };
};